var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase-method-detail-file-info"},[(_vm.fileFuns.get)?_c('file-manage',{attrs:{"file-data-ids":_vm.data.fileIds,"funs":_vm.fileFuns,"sortable":_vm.fileFuns.upload},on:{"addFile":_vm.addFile,"updateSort":_vm.updateFileSort,"delFile":_vm.delFile}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }